import React from "react";
import AppBar, { AppBarProps } from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import AtomicLogo from "../atoms/Logo";
import CIMATRIlogo from "../../CIMATRIlogo.png";
// import ASAElogo from "../../ASAElogo.png";
import { Link } from "react-router-dom";

const AtomicAppBar: React.FC<AppBarProps> = ({ children, ...rest }) => {
  return (
    <Box sx={{ display: "flex" }}>
      <AppBar {...rest} sx={{ backgroundColor: "white" }}>
        <Toolbar>
          <Link to="https://cimatri.com/" target="_blank">
            <AtomicLogo
              logoSrc={CIMATRIlogo}
              altText="Cimatri"
              imageStyle={{
                height: "20%",
                width: "150px",
              }}
            ></AtomicLogo>
          </Link>
          {/* <Link to="https://www.asaecenter.org/" target="_blank">
            <AtomicLogo
              logoSrc={ASAElogo}
              altText="ASAE"
              imageStyle={{
                height: "20%",
                width: "150px",
              }}
            ></AtomicLogo>
          </Link> */}
        </Toolbar>
      </AppBar>
      <Box component="main" sx={{ p: 3 }}>
        <Toolbar />
      </Box>
    </Box>
  );
};

export default AtomicAppBar;
